// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const NotificationSequence = t.struct({
    keyOrder: t.Array,
    langCd: t.String,
}, {
    name: 'NotificationSequence',
    strict: false,
});

export const getDefaultState = () => new NotificationSequence({
    keyOrder: [],
    langCd: '',
});

export default NotificationSequence;
